export default {
  // Header Section
  "discover_your": "உங்கள்",
  "life_predictions": "வாழ்க்கை முன்கணிப்புகள்",
  "future_unveiled_through_stars": "நட்சத்திரங்கள் வெளிப்படுத்தும் எதிர்காலம்",
  "life_predictions_description": "வேத ஜோதிடம் மற்றும் கிரக பகுப்பாய்வின் அடிப்படையில் முழுமையான வாழ்க்கை முன்கணிப்புகளைப் பெறுங்கள். எதிர்கால முக்கிய கட்டங்கள், வாழ்க்கை நிகழ்வுகள், தொழில் வளர்ச்சி, திருமண காலம், செல்வச் சேர்க்கை, ஆன்மீகப் பயணம் ஆகியவற்றை துல்லியமான ஜோதிட நுண்ணறிவுகளுடன் புரிந்துகொள்ளுங்கள்.",

  // Service Information
  "enter_details_for_predictions": "வாழ்க்கை முன்கணிப்புகளுக்கான உங்கள் விவரங்களை உள்ளிடுங்கள்",
  "complete_life_predictions": "முழுமையான வாழ்க்கை முன்கணிப்புகள்",
  "service_price": "சேவை விலை",
  "comprehensive_life_predictions_note": "உங்கள் எதிர்கால வாழ்க்கை நிகழ்வுகள் மற்றும் ஜோதிட வழிகாட்டுதலின் விரிவான பகுப்பாய்வு",

  // Form Fields
  "full_name": "முழுப் பெயர்",
  "enter_full_name": "உங்கள் முழுப் பெயரை உள்ளிடுங்கள்",
  "name_destiny_influence": "உங்கள் பெயர் அதிர்வுகள் உங்கள் விதி மற்றும் எதிர்கால வாய்ப்புகளை வடிவமைக்கின்றன",
  "email_address": "மின்னஞ்சல் முகவரி",
  "enter_email_address": "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுங்கள்",
  "phone_number": "தொலைபேசி எண்",
  "enter_phone_number": "உங்கள் தொலைபேசி எண்ணை உள்ளிடுங்கள்",
  "gender": "பாலினம்",
  "male": "ஆண்",
  "female": "பெண்",
  "other": "மற்றவை",
  "date_of_birth": "பிறந்த தேதி",
  "birth_date_future_insights": "கிரக காலங்கள் மற்றும் எதிர்கால முன்கணிப்புகளை கணக்கிட இவை அவசியம்",
  "time_of_birth": "பிறந்த நேரம்",
  "exact_time_critical_for_predictions": "தசா கணக்கீடுகள் மற்றும் முன்கணிப்புகளுக்குத் துல்லியமான நேரம் அவசியம்",
  "place_of_birth": "பிறந்த இடம்",
  "place_of_birth_placeholder": "நகரம், மாநிலம், நாடு",
  "location_essential_for_predictions": "இடம், எதிர்கால நிகழ்வுகளைப் பாதிக்கும் கிரக நிலைகளில் தாக்கம் செலுத்துகிறது",
  "preferred_language": "விருப்ப மொழி",
  "english": "ஆங்கிலம்",
  "hindi": "ஹிந்தி",
  "telugu": "தெலுங்கு",
  "kannada": "கன்னடம்",
  "language_note": "உங்கள் வாழ்க்கை முன்கணிப்புகள் தேர்ந்தெடுத்த மொழியில் வழங்கப்படும்",

  // Core Prediction Features
  "future_life_events_predictions": "எதிர்கால வாழ்க்கை நிகழ்வு முன்கணிப்புகள்",
  "career_success_timeline": "தொழில் வெற்றி காலவரிசை",
  "marriage_relationship_predictions": "திருமணம் & உறவு முன்கணிப்புகள்",
  "wealth_prosperity_forecast": "செல்வம் & வளம் முன்னறிவிப்பு",
  "health_longevity_insights": "ஆரோக்கியம் & ஆயுட்கால நுண்ணறிவுகள்",
  "pdf_download": "முழுமையான PDF அறிக்கை",

  "what_you_get": "உங்கள் வாழ்க்கை முன்கணிப்புகளில் உள்ளவை",
  "comprehensive_future_roadmap": "முழுமையான எதிர்கால சாலைவரைபடு",
  "major_life_events_timeline": "முக்கிய வாழ்க்கை நிகழ்வுகள் காலவரிசை",
  "planetary_influence_analysis": "கிரகத் தாக்கம் பகுப்பாய்வு",
  "remedial_guidance_solutions": "பரிகார வழிகாட்டுதல் & தீர்வுகள்",

  // Actions & Buttons
  "pay_and_generate_analysis": "என் வாழ்க்கை முன்கணிப்புகளை பெறவும்",
  "processing_payment": "கட்டணம் செயலாக்கப்படுகிறது",
  "processing_request": "முன்கணிப்புகள் உருவாக்கப்படுகின்றன",

  // Payment & Success Messages
  "thank_you": "நன்றி",
  "payment_successful": "கட்டணம் வெற்றிகரமாக முடிந்தது!",
  "life_predictions_processing": "உங்கள் வாழ்க்கை முன்கணிப்புகளை எங்கள் வேத ஜோதிட நிபுணர்கள் தயாரித்து வருகின்றனர். எதிர்கால நிகழ்வுகள் மற்றும் அண்ட காலவரிசை குறித்த விரிவான நுண்ணறிவுகள் வழங்கப்படும்.",
  "order_id": "ஆர்டர் ஐடி",
  "payment_id": "கட்டணம் ஐடி",
  "amount_paid": "செலுத்திய தொகை",

  // Delivery Information
  "delivery_information": "விநியோக தகவல்",
  "delivery_time": "பகுப்பாய்வு விநியோகம்",
  "within_24_hours_delivery_note": "உங்கள் விரிவான வாழ்க்கை முன்கணிப்புகள் 24 மணிநேரத்திற்குள் தயார் ஆகும்",
  "whatsapp_notification": "WhatsApp புதுப்பிப்புகள்",
  "whatsapp_delivery_note": "WhatsApp-ல் உடனடி அறிவிப்புகள் பெறுங்கள்",
  "email_delivery": "மின்னஞ்சல் விநியோகம்",
  "email_delivery_note": "முழு முன்கணிப்புகள் அனுப்பப்படும் முகவரி",

  // What You'll Receive
  "what_youll_receive": "உங்கள் வாழ்க்கை முன்கணிப்பு தொகுப்பு",
  "detailed_life_predictions": "முழுமையான வாழ்க்கை முன்கணிப்பு அறிக்கை (PDF)",
  "future_events_timeline": "எதிர்கால நிகழ்வுகளின் காலவரிசை & தேதிகள்",
  "career_marriage_wealth_predictions": "தொழில், திருமணம் & செல்வ முன்கணிப்புகள்",
  "planetary_periods_analysis": "கிரக காலங்கள் (தசா) பகுப்பாய்வு",
  "remedial_solutions_guidance": "பரிகாரத் தீர்வுகள் & வழிகாட்டுதல்",

  // Visual Content
  "sample_life_predictions": "மாதிரி வாழ்க்கை முன்கணிப்புகள்",
  "major_life_milestone": "முக்கிய வாழ்க்கை மைல் கல்",
  "sample_prediction_reading": "அடுத்த 2-3 ஆண்டுகளில் தொழில் முன்னேற்றமும் திருமண வாய்ப்புகளும்",
  "sample_predictions_preview": "காலவரிசை நுண்ணறிவுகளுடன் உங்கள் தனிப்பயன் வாழ்க்கை முன்கணிப்புகளின் முன்னோட்டம்",
  "life_prediction_areas": "வாழ்க்கை முன்கணிப்பு தளங்கள்",

  // Life Area Types
  "career": "தொழில்",
  "marriage": "திருமணம்",
  "wealth": "செல்வம்",
  "family": "குடும்பம்",
  "health": "ஆரோக்கியம்",
  "education": "கல்வி",

  // Status & Processing
  "your_predictions_status": "உங்கள் வாழ்க்கை முன்கணிப்புகள் நிலை",
  "processing_your_predictions": "உங்கள் எதிர்காலம் ஆய்வு செய்யப்படுகிறது",
  "predictions_processing_message": "உங்கள் ஜாதகத்தின் அடிப்படையில் கிரக காலங்கள் கணக்கிடப்பட்டு, எதிர்கால நிகழ்வுகள் பகுப்பாய்வு செய்யப்படுகின்றன.",
  "request_id": "பகுப்பாய்வு ஐடி",
  "status": "நிலை",
  "processing": "நடைபெறுகிறது",
  "pending": "வரிசையில் உள்ளது",
  "email_notification_sent": "உறுதிப்படுத்தும் மின்னஞ்சல் அனுப்பப்பட்டது",
  "whatsapp_update_coming": "WhatsApp புதுப்பிப்புகள் இயலுமைப்படுத்தப்பட்டுள்ளன",
  "delivery_within_24_hours": "அறிக்கை 24 மணிநேரத்தில் தயார்",

  // Support & Contact
  "contact_support": "ஜோதிட ஆதரவைத் தொடர்புகொள்ளுங்கள்",
  "need_help": "வழிகாட்டல் வேண்டுமா?",
  "contact_us_at": "எங்களை அணுக",

  // Error Messages
  "please_fill_all_required_fields": "தேவையான அனைத்து பிறப்பு விவரங்களையும் பூர்த்தி செய்யுங்கள்",
  "payment_failed": "கட்டணம் தோல்வியடைந்தது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
  "processing_failed": "முன்கணிப்புகள் செயலாக்கம் தோல்வியடைந்தது. எங்கள் ஆதரவைத் தொடர்புகொள்ளுங்கள்.",

  // Prediction-Specific Elements
  "planetary_periods": "கிரக காலங்கள் (தசாக்கள்)",
  "mahadasha": "மகாதசா காலங்கள்",
  "antardasha": "அந்தர்தசா உபகாலங்கள்",
  "pratyantar_dasha": "ப்ரத்யந்தர தசா",
  "transit_analysis": "கிரக கோச்சார பகுப்பாய்வு",
  "yogas_combinations": "சுபயோகங்கள் & அமைப்புகள்",

  // Life Events Predictions
  "career_milestones": "தொழில் மைல்கற்கள்",
  "job_changes": "வேலை மாற்றங்கள் & பதவி உயர்வுகள்",
  "business_opportunities": "வணிக வாய்ப்புகள்",
  "educational_achievements": "கல்விசார் சாதனைகள்",
  "marriage_timing": "திருமண கால நிர்ணயம்",
  "childbirth_predictions": "சந்ததி/பிள்ளை பெறுதல் முன்கணிப்புகள்",
  "property_acquisition": "செத்து/அசெத்து & நிலம் தொடர்பானவை",
  "travel_opportunities": "பயணம் & வெளிநாட்டு வாய்ப்புகள்",

  // Career Predictions
  "professional_growth": "தொழில்முறை வளர்ச்சி காலவரிசை",
  "success_periods": "வெற்றி & மரியாதை கிடைக்கும் காலங்கள்",
  "career_challenges": "தொழில் சவால் காலங்கள்",
  "leadership_roles": "தலைமை வாய்ப்புகள்",
  "business_ventures": "வணிக முயற்சி வெற்றி",
  "financial_growth": "நிதி வளர்ச்சி முறைபாடுகள்",

  // Marriage & Relationships
  "love_life_predictions": "காதல் வாழ்க்கை முன்கணிப்புகள்",
  "marriage_compatibility": "திருமண துணை இணக்கம்",
  "relationship_timing": "உறவு மைல்கற்கள்",
  "family_expansion": "குடும்ப வளர்ச்சி & குழந்தைகள்",
  "marital_harmony": "திருமண ஒற்றுமை காலங்கள்",
  "relationship_challenges": "உறவு சவால் காலங்கள்",

  // Wealth & Finance
  "wealth_accumulation": "செல்வச் சேர்க்கை காலவரிசை",
  "investment_success": "முதலீட்டு வெற்றி காலங்கள்",
  "property_gains": "சொத்து & சொத்து ஆதாயங்கள்",
  "business_profits": "வணிக லாபச் சுழற்சிகள்",
  "financial_setbacks": "நிதி சவால் காலங்கள்",
  "debt_recovery": "கடன் மீட்பு & நிதி நிலைத்தன்மை",

  // Health & Longevity
  "health_timeline": "ஆரோக்கிய காலவரிசை முன்கணிப்புகள்",
  "disease_periods": "ஆரோக்கிய சவால் காலங்கள்",
  "recovery_periods": "குணமாவதற்கான காலங்கள்",
  "longevity_analysis": "ஆயுட்கால & நீடித்த ஆயுள் பகுப்பாய்வு",
  "accident_prone_periods": "விபத்து ஏற்படக்கூடிய காலங்கள்",
  "vitality_enhancement": "உயிர்ச்சக்தி உயரும் காலங்கள்",

  // Family & Social
  "family_events": "குடும்ப நிகழ்வுகள் & மைல்கற்கள்",
  "children_predictions": "குழந்தைகள் தொடர்பான முன்கணிப்புகள்",
  "parental_health": "பெற்றோரின் ஆரோக்கியம் & நலன்",
  "sibling_relationships": "உடன்பிறப்புகள் உறவுகள்",
  "social_recognition": "சமூக அந்தஸ்து & மரியாதை",
  "community_involvement": "சமூகத் தலைமை & பங்களிப்பு",

  // Spiritual & Personal Growth
  "spiritual_awakening": "ஆன்மீக விழிப்பு காலங்கள்",
  "religious_inclinations": "மத & ஆன்மீக விருப்பங்கள்",
  "pilgrimage_opportunities": "ஊர்வலம் & புனித பயணங்கள்",
  "meditation_periods": "தியானம் & உள் வளர்ச்சி காலங்கள்",
  "guru_connections": "ஆன்மீக குரு இணைப்புகள்",
  "moksha_path": "மோக்ஷம் & ஞானப் பாதை",

  // Timing & Cycles
  "auspicious_periods": "சுப காலங்கள்",
  "challenging_periods": "சவாலான காலங்கள்",
  "neutral_periods": "நடுநிலை & நிலைமையான காலங்கள்",
  "transformation_phases": "பெரும் மாற்றக் கட்டங்கள்",
  "opportunity_windows": "வாய்ப்பு துளைகள்",
  "decision_making_periods": "முக்கிய முடிவு எடுப்பதற்கான சிறந்த நேரங்கள்",

  // Age-Based Predictions
  "childhood_predictions": "சிறுவயது & ஆரம்ப வாழ்க்கை",
  "teenage_predictions": "இளமை & யௌவனக் கால முன்கணிப்புகள்",
  "young_adult_phase": "இளைய முதிர் காலம் (20-35)",
  "middle_age_predictions": "நடு வயது முன்கணிப்புகள் (35-55)",
  "senior_years": "மூப்பு & ஓய்வு காலம்",
  "life_completion": "வாழ்க்கை நிறைவு & மரபு (Legacy)",

  // Remedies & Solutions
  "planetary_remedies": "கிரக பரிகாரங்கள்",
  "gemstone_recommendations": "ரத்தின பரிந்துரைகள்",
  "mantra_chanting": "பயனுள்ள மந்திர ஜபம்",
  "charity_suggestions": "தான தர்ம ஆலோசனைகள்",
  "ritual_recommendations": "பூஜை & அனுஷ்டான பரிந்துரைகள்",
  "lifestyle_modifications": "வாழ்க்கைமுறை மாற்றங்கள்",

  // Advanced Predictions
  "karma_analysis": "கர்ம முறைபாடுகள் பகுப்பாய்வு",
  "past_life_influences": "முன் பிறவித் தாக்கங்கள்",
  "soul_purpose": "ஆத்தும நோக்கம் & பணி",
  "destiny_fulfillment": "விதி நிறைவேற்றப் பாதை",
  "life_lessons": "முக்கிய வாழ்க்கைப் பாடங்கள்",
  "evolutionary_growth": "ஆத்தும வளர்ச்சி (Evolutionary Growth)",

  // Specific Event Timing
  "marriage_age_prediction": "திருமண வயது முன்கணிப்பு",
  "first_child_timing": "முதல் குழந்தை கால நிர்ணயம்",
  "career_peak_period": "தொழில் உச்சக் காலம்",
  "maximum_wealth_phase": "அதிகபட்ச செல்வக் கட்டம்",
  "health_recovery_timing": "ஆரோக்கிய மீட்பு நேரம்",
  "spiritual_realization": "ஆன்மீக உணர்வு கட்டம்",

  // Global & Environmental
  "foreign_opportunities": "வெளிநாட்டு பயணம் & வாய்ப்புகள்",
  "relocation_predictions": "இடமாற்றம் & குடியேற்றம்",
  "global_connections": "சர்வதேச இணைப்புகள்",
  "cultural_exchanges": "கலாச்சார & கல்வி பரிமாற்றங்கள்",
  "technology_adaptations": "தொழில்நுட்பம் & புதுமை பங்கேற்பு",

  // Detailed Time Frames
  "next_year_predictions": "அடுத்த ஆண்டுக்கான முன்கணிப்புகள்",
  "next_5_years": "அடுத்த 5 ஆண்டுகளின் மேலோட்டம்",
  "next_10_years": "அடுத்த 10 ஆண்டுகளின் முன்னறிவிப்பு",
  "life_phases": "முக்கிய வாழ்க்கை கட்டங்கள்",
  "cyclical_patterns": "திரும்பத் திரும்ப நிகழும் வாழ்க்கை முறைபாடுகள்",
  "milestone_achievements": "பெரும் மைல்கல் சாதனைகள்"
};
